module.exports = __webpack_public_path__ + "media/src/images/icons/star/active-751188d90992379db44b3eb65782d402.svg";